// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__5GzQI","content":"RecentSearches_content__2qmzQ"};